<h2 matDialogTitle>Add Workout</h2>
<mat-dialog-content>
  <mat-selection-list (selectionChange)="updateSelection($event)">
    <mat-list-option [value]="customValue" [selected]="selected === customValue">Custom…</mat-list-option>
    <mat-list-option [value]="libraryValue" [selected]="selected === libraryValue">From Library…</mat-list-option>
    <mat-list-option *ngFor="let workoutType of workoutTypes" [value]="workoutType.id" [selected]="selected === workoutType.id">{{
      workoutType.name
    }}</mat-list-option>
    <mat-list-option [value]="restrictedValue" [selected]="selected === restrictedValue">Other</mat-list-option>
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
  <button mat-button matDialogClose>Close</button>
  <button mat-raised-button color="primary" [matDialogClose]="result">Add Selected</button>
</mat-dialog-actions>
